// src/services/api/bannerService.js
import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const bannerService = {
  // Lấy danh sách banner mobile
  get_banner: async (token, { page = 1, limit = 5 } = {}) => {
    const response = await https.get(`${API_ROUTES.BANNER.GET_ALL}`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { page, limit },
    });
    return response;
  },

  // Lấy chi tiết (giữ nguyên như bạn đang có)
  get_detail: (token, banner_id) => {
    return https.get(`${API_ROUTES.BANNER.GET_BY_ID}/${banner_id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
